import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../../../base/base-component.component';
import { TranslateService } from '@ngx-translate/core';
import { NgxFileDropEntry } from '../../../shared/ngx-file-drop/ngx-file-drop-entry';
import { AssetFacade } from '../../../services/akita/asset-schema/asset.facade';
import { FileSystemFileEntry } from '../../ngx-file-drop/dom.types';
import { Asset, AssetDirectoryFacade } from '../../../services';
import { Validation } from '../../../tools';
import { result } from 'lodash';
declare var $;

@Component({
  selector: 'app-upload-field',
  templateUrl: './upload-field.component.html',
  styleUrls: ['./upload-field.component.css'],
})
export class UploadFieldComponent extends BaseComponent implements OnInit {

  @Input()
  schemaName: string;

  @Input()
  fieldName: string;
  
  @Input()
  value: string[];

  @Input()
  uniqueFieldControlId: string;

  @Output()
  fileUploaded = new EventEmitter<any>();

  assetName: string[] = [];

  assetPath: any = '';

  file: Asset[] = [];

  newImage: any ;

  @Output()
  newImageEmitter = new EventEmitter<any>();

  @Output()
  deleteAssetEmitter = new EventEmitter<any>();

  files: NgxFileDropEntry[] = [];

  filesToUpload: any[] = [];

  fileCount: number = 0;
  
  constructor(
    private readonly  assetFacade: AssetFacade,
    private readonly  assetDirectoryFacade: AssetDirectoryFacade,
    translateService: TranslateService
  ) {
    super(translateService);
    this.setTranslateContext('UploadField');
  }

  ngOnInit() {
    for (let i = 0; i < this.value.length; i++) {
      if (Validation.isValidGuid(this.value[i])) {

        this.assetFacade.getById(this.value[i]).subscribe(file => {
          this.assetName[i] = file.fileName;
          this.file[i] = file;
          this.assetPath = this.assetFacade.path;
        });
      }
    }
  }

  uploadFiles(event) {
    console.log(event);
  }

  // We only handle one dropped asset at a time.
  dropped(files: NgxFileDropEntry[]) {
    this.files = files;

    if (this.assetName.length > 0) {
      const imgs = $(".thumbnail-div-" + this.fieldName).find('img');
      imgs.each((index, img) => {
        if (img.currentSrc && img.currentSrc.includes('data:')) {
          console.log('found');
        } else {
          this.deleteImage(this.file[0], img);
        }


      });
      
    //  const img:any = document.querySelector(".thumbnail-div-" + this.fieldName).querySelectorAll('img');
    //  if (img) {
    //    for (const im of img) {
    //      if (im.currentSrc.contains('data:')) {
    //        img.remove()
    //      }

    //    }
    //  }
    }


    for (let i = 0; i < files.length; i++) {

      const fileEntry = files[i].fileEntry as FileSystemFileEntry;
      let images: any;

      fileEntry.file((file: File) => {
        // Only process image files.
        const reader = new FileReader();
        // Closure to capture the file information.
        let self = this;
        reader.onload = (function (theFile) {
          return function (event) {

            const imageDiv = document.querySelector(".thumbnail-div-" + self.fieldName + "-" + self.uniqueFieldControlId);

            let newElem: any = document.createElement("img");
            newElem.src = event.target.result;
            newElem.classList.add("thumbnail-link-" + self.fieldName + "-" + self.uniqueFieldControlId);
            newElem.classList.add("image-changed");
            newElem.classList.add("thumbnail-image");
            newElem.style.width = "200px";
            newElem.style.maxHeight = "195px";
            newElem.style.marginLeft = "3rem";

            const divOverlayElem: HTMLElement = document.createElement("div");
            divOverlayElem.classList.add("overlay");
            divOverlayElem.style.textAlign = "right";
            divOverlayElem.style.padding = "5px";

            const id = "ico-" + Math.floor(Math.random() * 9999);
            const trashElem: any = document.createElement("i");
            trashElem.classList.add("fa");
            trashElem.classList.add("fa-trash");
            trashElem.classList.add("cursor-pointer");
            trashElem.ariaHidden = "true";
            trashElem.style.marginRight = "4rem";
            trashElem.style.color = "#F29100";
            trashElem.style.fontSize = "20px"
            trashElem.id = id;
            divOverlayElem.appendChild(trashElem);
            imageDiv.append(divOverlayElem);

            imageDiv.appendChild(newElem);
            imageDiv.classList.add("image-changed");
            let newElem2: any = document.createElement("input");
            newElem2.classList.add("label-image");
            newElem2.classList.add("form-control");
            newElem2.style.margin = "1rem 1rem 1rem 3rem";
            newElem2.style.width = "70%";
            newElem2.value = files[0].relativePath;
            newElem2.readOnly = true;
            newElem2.id = 'imageFileName'
            imageDiv.append(newElem2);
            $("#" + id).on("click", function () {
              const elem = $(this).closest('.thumbnail-area');

              if (elem.length > 0) {
                elem.empty();
              }


                self.assetName[0] = '';

              const index = self.filesToUpload.findIndex(v => v.name === file.name);

              self.filesToUpload.splice(index, 1);

              self.deleteAssetEmitter.emit(images);

            })
          };
        })(file);

        reader.readAsDataURL(file);
        this.filesToUpload = [];
        this.filesToUpload.push(file);

        this.fileCount++;
        images = {
          fieldName: this.fieldName,
          files: this.filesToUpload,
          isDeleted: false
        };
        this.newImageEmitter.emit(images);
      });

    }

  }

  assetExist() {
    return Validation.isValidGuid(this.value[0]);
  }

  fileOver($event: any) {
  }

  fileLeave($event: any) {
  }

  deleteCurrentAsset() {
    const index = 0;
    this.assetFacade.remove(this.value[index]).subscribe(() => {
      this.assetName[index] = '';
      this.value[index] = '';
    });
  }

  downloadCurrentAsset() {
    const data = 'todo';
    const blob = new Blob([data], { type: 'application/octet-stream' });

    //this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
  }

  fileIsValid(file: Asset) {
    try {
      if (typeof file === 'undefined') {
        return false;
      } else if (typeof file['id'] === 'undefined') {
        return false;
      } else {
        return true;
      }
    }
    catch (err) {
      console.log(err);
      console.log(JSON.stringify(file));
    };
  }

  deleteImage(file: any, element : ElementRef) {
    let img = document.querySelector(`.thumbnail-div-${this.fieldName}-${this.uniqueFieldControlId}`).querySelector(`[src*='${file.id}']`);

    if (img) {
      img.classList.add('d-none');
      $(img).parent().parent().find("#imageFileName").addClass('d-none')
    }

    if (element) {
      const elem = $(element).find().parent().parent().find('img');
      elem.addClass('d-none');
      elem.parent().parent().find("#imageFileName").addClass('d-none')
    }

    this.assetName[0] = '';

    const index = this.filesToUpload.findIndex(v => v.name === file.name);

    this.filesToUpload.splice(index, 1);

    let images = {
      fieldName: this.fieldName,
      assets: [file]
    };

    this.deleteAssetEmitter.emit(images);

  }

  showThumbnail(item: Asset) {
    if (item.isImage || item.tags.findIndex(a => a === 'type/ico') >= 0 || item.tags.findIndex(a => a === 'type/svg') >= 0) {
      return true;
    } else {
      return false;
    }
  }

}
